import { enableProdMode, Type } from '@angular/core';
import { environment } from './environments/environment';
import { ConfigService, ensureLocaleDataLoaded, getPreferredLanguageCode } from '@assist/shared/data';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig, notEnabledConfig } from './app.config';
import { ServerType } from '@cue/api';
import { CalendarsService } from '@cue/calendars';
import { NotEnabledAppComponent } from './not-enabled-app/not-enabled-app.component';

if (environment.production) {
  enableProdMode();
}

const configService = new ConfigService();

const calendarImplementations: Record<ServerType, () => Promise<Type<CalendarsService>>> = {
  gspace: () => import('@cue/calendars/gspace').then((x) => x.GSpaceCalendarService),
  ews: () => import('@cue/calendars/ews').then((x) => x.EWSCalendarService),
  'touchone-calendar': () => import('@cue/calendars/touchone').then((x) => x.TouchoneCalendarService),
  o365: () => import('@cue/calendars/o365').then((x) => x.O365CalendarService),
};

const bootstrap = (calendarService: Type<CalendarsService>) =>
  bootstrapApplication(AppComponent, appConfig(configService, calendarService));

const notEnabledBootstrap = () => bootstrapApplication(NotEnabledAppComponent, notEnabledConfig(configService));

const startupLanguage = getPreferredLanguageCode();
ensureLocaleDataLoaded(startupLanguage)
  .then(() => configService.prebootstrapLoad())
  .catch((e) => {
    if (e === 'not-configured' || e === 'missing-license') {
      return Promise.resolve([false, e]);
    }
    throw e;
  })
  .then(([correctStart, issue]) => {
    if (correctStart) {
      const url = new URL(window.location.href);
      if (url.searchParams.has('bootstrapIssue')) {
        // redirect to '/'
        location.href = url.origin;
      }
      return calendarImplementations[configService.value.serverType]().then((calendarService) => {
        bootstrap(calendarService).catch((err) => console.log(err));
      });
    } else {
      const url = new URL(window.location.href);
      if (!url.searchParams.has('bootstrapIssue')) {
        url.searchParams.append('bootstrapIssue', issue);
        window.history.replaceState({}, '', url);
      }

      return notEnabledBootstrap().catch((err) => console.log(err));
    }
  })

  .catch((error) => {
    window.alert(error);
  });
